import { convertPattern, ConvertPatternError, IpaOrFeature } from "../pattern/convertPattern";
import { Pattern } from "../pattern/pattern";
import { PhonemeInfo } from "../pattern/phonemeInfo";

export interface SyllablePhonotactics<T> {
  readonly affricates?: 'all-aff' | 'en-aff';
  readonly onset: Pattern<T>;
  readonly nucleus: Pattern<T>;
  readonly coda: Pattern<T>;
}

export interface ConvertPTResults {
  phonotactics: SyllablePhonotactics<PhonemeInfo>;
  errors: ConvertPatternError[];
}

/** convert from a simple input format to the form used by various functions */
export function convertPhonotactics(input: SyllablePhonotactics<IpaOrFeature>): ConvertPTResults {
  const onset = convertPattern(input.onset, input.affricates);
  const nucleus = convertPattern(input.nucleus, input.affricates);
  const coda = convertPattern(input.coda, input.affricates);
  const errors = onset.errors.filter(e => e.error.length > 0).concat(
    nucleus.errors.filter(e => e.error.length > 0)).concat(
      coda.errors.filter(e => e.error.length > 0));
  return {
    phonotactics: {
      affricates: input.affricates,
      onset: onset.pattern,
      nucleus: nucleus.pattern,
      coda: coda.pattern
    },
    errors
  }
}
